/**
 * Verbs: the infinitive, type what it means.
 *
 * A verb has no article and no plural, so the frame stays plain. What it does
 * carry is what the bare infinitive hides — whether it separates
 * (anfangen → er fängt an) and whether it is used reflexively ((sich) freuen).
 * Both change how the word behaves in a sentence, so both are on the front:
 * they are part of knowing the word, not the answer to it.
 */
import { TypeTranslationCardFront } from '@/components/practice/TypeTranslationCard';
import type { VerbPayload } from '@/core/types';

import type { CardFrontProps } from '../types';

export function CardFront({ card, onAnswer }: CardFrontProps<VerbPayload>) {
  const { separable, reflexive } = card.payload;
  const markers = [separable && 'separable', reflexive && 'reflexive'].filter(Boolean);
  return (
    <TypeTranslationCardFront
      card={card}
      onAnswer={onAnswer}
      headword={
        <>
          {reflexive && <span className="text-muted-foreground">sich </span>}
          {card.de}
        </>
      }
      subtitle={markers.length > 0 ? markers.join(' · ') : null}
    />
  );
}
